<template>
<div class="content-body tenant-settings">
    <el-tabs v-model="activeName" @change="changeTabHandle">
        <el-tab-pane :key="1" label="包装运输费统计" name="costPage">
            <el-form :model="dataForm" :rules="dataRule" size="mini" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="150px" class="org-dialog-form" v-loading="dataFormLoading">
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="每个零件运输成本" prop="transportCost">
                            {{fixedNumber(dataForm.transportCost)}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="每个包装箱体积(m³)" prop="boxVolume">
                            <ctl-number v-model="dataForm.boxVolume" maxlength="200" :min="0" :max="1000000000"></ctl-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="每箱中零件数量" prop="partNum">
                            <ctl-number v-model="dataForm.partNum" maxlength="200" :min="0" :max="1000000000"></ctl-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="每m³运费(元/m³)" prop="transportFee">
                            <ctl-number v-model="dataForm.transportFee" maxlength="200" :min="0" :max="1000000000"></ctl-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <!-- <el-form-item label="询报价ID">
                            <el-input v-model="dataForm.rfqId" placeholder="询报价ID" style="width:300px" maxlength="10"></el-input>
                        </el-form-item>
                        <el-form-item label="零件ID">
                            <el-input v-model="dataForm.partId" placeholder="零件ID" style="width:300px" maxlength="10"></el-input>
                        </el-form-item>
                        <el-form-item label="供应商ID">
                            <el-input v-model="dataForm.supplierId" placeholder="供应商ID" style="width:300px" maxlength="10"></el-input>
                        </el-form-item> -->
                        <el-form-item label="计算公式">
                            每个包装箱体积(m³) ÷ 每箱中零件数量 * 每m³运费(元/m³) = 每个零件运输成本
                        </el-form-item>
                        <!-- <el-form-item label="轮次">
                            <el-input v-model="dataForm.roundNo" placeholder="轮次" style="width:300px" maxlength="10"></el-input>
                            {{dataForm.roundNo}}
                        </el-form-item> -->
                    </el-col>
                </el-row>
                <!-- <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="每个零件包装成本" prop="boxCost">
                            {{fixedNumber(dataForm.boxCost)}}
                        </el-form-item>
                    </el-col>
                </el-row> -->
                <!-- <el-row :gutter="10">
                    <el-col :span="12"> -->
                        <!-- <el-form-item label="询报价ID">
                            <el-input v-model="dataForm.rfqId" placeholder="询报价ID" style="width:300px" maxlength="10"></el-input>
                        </el-form-item>
                        <el-form-item label="零件ID">
                            <el-input v-model="dataForm.partId" placeholder="零件ID" style="width:300px" maxlength="10"></el-input>
                        </el-form-item>
                        <el-form-item label="供应商ID">
                            <el-input v-model="dataForm.supplierId" placeholder="供应商ID" style="width:300px" maxlength="10"></el-input>
                        </el-form-item> -->
                        <!-- <el-form-item label="计算公式">
                            每个包装箱成本 ÷ 每箱中零件数量 = 每个零件包装成本
                        </el-form-item> -->
                        <!-- <el-form-item label="轮次">
                            <el-input v-model="dataForm.roundNo" placeholder="轮次" style="width:300px" maxlength="10"></el-input>
                            {{dataForm.roundNo}}
                        </el-form-item> -->
                    <!-- </el-col>
                </el-row> -->
            </el-form>
            <el-row :gutter="40">
                <el-col :span="8" style="text-align:center">
                    <el-button size="small" type="primary" plain v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'" @click="dataFormSubmit()">
                        保存
                    </el-button>
                    <el-button size="small" icon="el-icon-refresh" plain @click="loadFormData()">
                        刷新
                    </el-button>
                </el-col>
            </el-row>
        </el-tab-pane>
        <el-tab-pane :disabled="dataForm.id===''"  :key="2" label="包装箱成本明细" name="detailPage">
            <el-descriptions class="margin-top" :column="1" size="small" border style="margin-bottom: 5px;">
                        <el-descriptions-item label="每个零件包装成本:">
                                <span>{{fixedNumber(dataForm.boxCost)}}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="计算公式:">
                            <span>每个包装箱成本 ÷ 每箱中零件数量 = 每个零件包装成本</span>
                        </el-descriptions-item>
            </el-descriptions>
            <el-row style="text-align:right; margin-bottom:15px">
                <el-col>
<!--                    <el-button size="mini" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">-->
<!--                        新建-->
<!--                    </el-button>-->
                  <el-button size="mini" type="primary" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'"  plain @click="save()">
                    <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;保存
                  </el-button>
                  <el-button size="mini" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addHandleNewRow()" icon="el-icon-plus">
                    新增
                  </el-button>
                    <el-button size="mini" icon="el-icon-refresh" plain @click="reLoadData2()">
                        刷新
                    </el-button>
                </el-col>
            </el-row>

          <el-table-edit
              v-model="dataList"
              :columns="['materialName','userdNum', 'unitPrice']"
              ref="editTable"
          >
            <el-table :data="dataList" row-key="id" size="mini" border style="width: 100%;" :header-cell-style="{background:'#f5f5f5'}" :default-expand-all="false" :height="tableHeight" v-loading="dataListLoading">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="materialName" header-align="center" align="left" label="材料名称">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="materialName"
                    >
                      <template slot-scope="{ rowStates }">
                        <span v-show="!rowStates.editing">{{row.materialName}}</span>
                        <el-input
                            size="mini"
                            v-show="rowStates.editing"
                            v-model="row.materialName"
                            clearable
                        >
                        </el-input>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="userdNum" header-align="center" align="right" label="使用量">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="userdNum"
                    >
                      <template slot-scope="{ rowStates }">
                        <span v-show="!rowStates.editing">{{row.userdNum}}</span>
                        <ctl-number :precision="3" :p="0" :min="0" v-show="rowStates.editing" v-model="row.userdNum" maxlength="200"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="unitPrice" header-align="center" align="right" label="单价">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="unitPrice"
                    >
                      <template slot-scope="{ rowStates }">
                        <span v-show="!rowStates.editing">{{row.unitPrice}}</span>
                        <ctl-number :precision="3"  :min="0" v-show="rowStates.editing" v-model="row.unitPrice" maxlength="200"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column header-align="center" align="left" width="190" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" v-show="scope.row.id !==''" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" v-show="scope.row.id !==''" size="small" :disabled="viewFlag != 'view'? false :true" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" :disabled="viewFlag != 'view'? false :true" @click="deleteHandle(scope.row)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
          </el-table-edit>
            <!-- 分页 -->
            <!-- <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination> -->
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshBoxDataList="getDataList" @loadFormDataAll = "loadFormDataAll"></add-or-update>
        </el-tab-pane>
    </el-tabs>

</div>
</template>

<script>
import {
    boxGetByParam,
    boxDetailDelete,
    boxDetailList,
    addPartPrice,
    editPartPrice,
    boxInsert,
    boxUpdate,
  boxDetailInsertBatch,
  getQuotationDetail
} from '@/controller/quotation'
import AddOrUpdate from './quotationBox-add-or-update'
import moment from 'moment'
import {
    mapping
} from "@/utils"
import CtlNumber from '@/views/common/ctl-number'
// require('@/mock/mockQuotation');
export default {
    props: {
        roundNo: Number,
        dataFromParent:Object
    },
    components: {
        AddOrUpdate,
        CtlNumber
    },
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            activeName: '',
            dataForm: {
                id: '',
                rfqId: '',
                rfqPartId: '',
                rfqSupplierId: '',
                roundNo: '',
                boxCost: 0,
                partNum: 0,
                boxVolume: 0,
                transportFee: 0,
                transportCost: 0,
            },
            viewFlag: '',
            dataRule: {},
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataFormLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    watch: {
        'dataForm.partNum': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                //console.log('dataForm.partNum', nval)
                if (this.dataForm.partNum == 0) {
                    this.$message.warning("零件数量不能为0");
                    return false
                } else {
                    // 每个包装箱体积(m³) ÷ 每箱中零件数量 * 每m³运费(元/m³) = 每个零件运输成本
                    if(Number.isNaN(nval) || nval === undefined){
                        return 0
                    }
                    if (this.dataForm.partNum * nval !== 0) {
                        this.dataForm.transportCost = this.dataForm.boxVolume / nval * this.dataForm.transportFee
                    } else {
                        this.dataForm.transportCost = 0
                    }
                    let unitPriceSum = 0;
                    for (let index = 0; index < this.dataList.length; index++) {
                        const element = this.dataList[index].unitPrice * this.dataList[index].userdNum;
                        unitPriceSum += element;
                    }
                    //if(unitPriceSum >0){
                    this.dataForm.boxCost = unitPriceSum/this.dataForm.partNum
                    //}
                }
                
            },
            deep: true, // 深度监听
        },
        'dataForm.boxVolume': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                // 每个包装箱体积(m³) ÷ 每箱中零件数量 * 每m³运费(元/m³) = 每个零件运输成本
                if (this.dataForm.partNum * nval !== 0) {
                    this.dataForm.transportCost = nval / this.dataForm.partNum * this.dataForm.transportFee
                } else {
                    this.dataForm.transportCost = 0
                }
            },
            deep: true, // 深度监听
        },
        'dataForm.transportFee': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                if (this.dataForm.partNum * nval !== 0) {
                    this.dataForm.transportCost = this.dataForm.boxVolume / this.dataForm.partNum * nval
                } else {
                    this.dataForm.transportCost = 0
                }
            },
            deep: true, // 深度监听
        },

    },
    computed: {
      editTable() {
        return this.$refs.editTable
      },
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 325
            }
        }
    },
    // activated() {
    //     this.init(1, 1, 1);
    // },
    methods: {
      save() {
        var ins = []
        var upd = []
        this.dataList.forEach(value => {
          if (value.id !== '') {
            upd.push(value)
          } else {
            ins.push(value)
          }
        })
        if (ins.length > 0) {
          var params = {
            "list": ins,
            "rfqId": this.dataForm.rfqId,
            "subcompanyId":this.dataFromParent.subcompanyId
          }
          // 创建表
          boxDetailInsertBatch(params)
              .then((data) => {
                if (data && data.code === "00") {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                  });
                  this.loadFormDataAll()
                } else {
                  this.$message.error(data.msg);
                }
                this.loadFormData()
              })
              .catch((error) => {
                console.log(error);
              });

        }

      },
    //新一行
      getNewRowData() {
        return {
          'id':'',
          'rfqId': this.dataForm.rfqId,
          'rfqPartId': this.dataForm.rfqPartId,
          'rfqSupplierId': this.dataForm.rfqSupplierId,
          'materialName':'',
          'userdNum':'',
          'unitPrice':'',
          'boxTriansportId':this.dataForm.id,
          'roundNo':this.dataForm.roundNo!==null ? this.dataForm.roundNo:'0',
          'rowNum':this.rowNum
        }
      },
      // 新增行
      addHandleNewRow() {
        const newRow = this.getNewRowData()
        this.editTable.newRows([newRow])
        this.rowNum += 1
      },

        // init(rfqId = 0, roundNo = 0, supplierId = 0) {
        //     this.dataForm.rfqId = rfqId;
        //     this.dataForm.roundNo = roundNo;
        //     this.dataForm.supplierId = supplierId;
        //     boxGetByParam({
        //         'rfqId': rfqId,
        //         'roundNo': roundNo,
        //         'supplierId': supplierId
        //     }).then(data => {
        //         if (data && data.code === '00' && data.body) {
        //             this.dataForm = data.body
        //             this.getDataList()
        //         }
        //     });

        // },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        init(rfqId = 0, rfqPartId = 0, supplierId = 0, roundNo = 0, viewFlag) {
            this.activeName = 'costPage'
            this.dataForm = []
            this.dataForm.rfqId = rfqId
            this.dataForm.rfqPartId = rfqPartId
            this.dataForm.rfqSupplierId = supplierId
            this.dataForm.roundNo = roundNo
            this.viewFlag = viewFlag
            this.dataForm.subcompanyId=this.dataFromParent.subcompanyId
            this.pageIndex = 1
            this.getDataList()
        },
        // 获取数据列表
        getDataList() {
            this.dataForm.id = '';
            this.dataList = [];
            this.dataListLoading = true
            this.loadFormData();
        },
        loadFormDataAll() {

            let {
                rfqId,
                rfqPartId,
                rfqSupplierId,
                roundNo
            } = this.dataForm;
            // this.dataFormLoading = true;
            boxGetByParam({
                rfqId,
                rfqPartId,
                rfqSupplierId,
                roundNo
            }).then(data => {
                if (data && data.code === '00' && data.body) {
                    // mapping(data.body, this.dataForm)
                  this.dataForm = data.body
                  if(this.dataForm.id !== ''){
                    boxDetailList({
                      pageNo: 1,
                      pageSize: -1,
                      totalPage: this.totalPage,
                      boxTriansportId: this.dataForm.id
                    }).then(data => {
                      if (data && data.code === '00') {
                        data.body.boxCost
                        this.saveSum(this.dataForm.boxCost)
                      }
                      setTimeout(() => {
                        this.dataListLoading = false
                      }, 200)

                    })
                  }
                }else{
                  console.log("boxGetByParam请求失败",data)
                }
            });
        },
        loadFormData() {
            let {
                rfqId,
                rfqPartId,
                rfqSupplierId,
                roundNo
            } = this.dataForm;
            // this.dataFormLoading = true;
            boxGetByParam({
                rfqId,
                rfqPartId,
                rfqSupplierId,
                roundNo
            }).then(data => {
                if (data && data.code === '00' && data.body) {
                    // mapping(data.body, this.dataForm)
                  this.dataForm = data.body
                  if(this.dataForm.id !== ''){
                    boxDetailList({
                      pageNo: 1,
                      pageSize: -1,
                      totalPage: this.totalPage,
                      boxTriansportId: this.dataForm.id
                    }).then(data => {
                      if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                        //计算每个零件包装成本
                        let unitPriceSum = 0;
                        for (let index = 0; index < this.dataList.length; index++) {
                            const element = this.dataList[index].unitPrice * this.dataList[index].userdNum;
                            unitPriceSum += element;
                        }
                        this.dataForm.boxCost = unitPriceSum/this.dataForm.partNum
                      } else {
                        this.dataList = []
                        this.totalPage = 0
                      }
                      setTimeout(() => {
                        this.dataListLoading = false
                      }, 200)

                    })
                  }
                }else{
                  console.log("boxGetByParam请求失败",data)
                }
            });

        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, this.dataForm.id, 'view', this.dataForm, this.dataFromParent.rfqId)
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            console.log("new")
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, this.dataForm.id, 'edit', this.dataForm, this.dataFromParent.rfqId)
            })
        },
        // 删除
        deleteHandle(row) {
          //console.log("row",row)
          //console.log("this.dataFromParent.rfqId",this.dataFromParent.rfqId)
          if (row.id!==''){
            if (row && this.dataFromParent.rfqId) {
              getQuotationDetail({}, this.dataFromParent.rfqId).then(data => {
                  if (data && data.code === '00') {
                      if("2" != data.body.rfqStatus) {
                          this.$message.warning("询价单不是询价中状态，不允许删除报价相关信息")
                      } else {
                          this.$confirm(`确定进行删除操作?`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                          }).then(() => {
                            boxDetailDelete({}, row.id).then(data => {
                              if (data && data.code === '00') {
                                this.$message({
                                  message: '操作成功',
                                  type: 'success',
                                  duration: 1500,
                                  onClose: () => {
                                    this.getDataList()
                                  }
                                })
                                this.loadFormDataAll()
                              } else {
                                this.$message.error(data.msg)
                              }
                            })
                          })
                      }
                  }
              })
            }
          }else {
            //未保存的 直接删除行
            var a = []
            a.push(row)
            this.editTable.delRows(a)
          }
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                if (this.dataForm.partNum == 0) {
                    this.$message.warning("零件数量不能为0");
                    return false
                } else {
                    let params = this.dataForm
                    if (valid) {
                        if (this.dataForm.id) {
                            boxUpdate(params).then(data => {
                                if (data && data.code === '00') {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success',
                                        onClose: () => {}
                                    })
                                    this.saveSum(this.dataForm.boxCost)
                                    this.loadFormData()
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })
                        } else {
                            boxInsert(params).then(data => {
                                if (data && data.code === '00') {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success',
                                        onClose: () => {}
                                    })
                                    this.saveSum(this.dataForm.boxCost)
                                    this.loadFormData()
                                } else {
                                    this.$message.error(data.msg)
                                }

                            })
                        }
                    }
                }
            })
        },
        saveSum(boxCost){
            let params = this.dataFromParent
            params.rfqId = this.dataFromParent.rfqId
            console.log(boxCost);
            params.packageFee = this.fixedNumber(boxCost)
            params.transportFee = this.dataForm.transportCost
            // 制造成本小计(D=A+B+C)
            params.productionCostSum = this.fixedNumber(params.materialCost) + this.fixedNumber(params.outsidePartCost) 
                + this.fixedNumber(params.processingCost)
            // 产品单价(J=D+H+I+K+L)
            params.productUnitPrice = this.fixedNumber(params.productionCostSum) + this.fixedNumber(params.midiumCostSum)
                + this.fixedNumber(params.profit) + this.fixedNumber(params.packageFee) 
                + this.fixedNumber(params.transportFee) 
            // 产品价格总计
            params.feeCostSum = this.fixedNumber(params.productUnitPrice) + this.fixedNumber(params.toolsPartAllocation)
                + this.fixedNumber(params.designPartAllocation) 
            if (params.id) {
                editPartPrice(params).then(data => {
                    if (data && data.code === '00') {
                        // this.dataForm.id = data.body.id;
                        // this.dataForm = data.body;
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                        })
                        this.getDataList()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            } else {
                addPartPrice(params).then(data => {
                    if (data && data.code === '00' && data.body) {
                        this.dataFromParent.id = data.body.id;
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                        })

                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        },
        reLoadData2() {
            // let {
            //     rfqId,
            //     supplierId,
            //     roundNo
            // } = this.dataForm;
            this.pageIndex = 1
            this.getDataList()
        },
        fixedNumber(val) {
            if (!val) {
                return 0
            }
            return Number(Number(val).toFixed(3))
        },
        changeTabHandle(val) {
            if (this.activeName === 'costPage') {
                this.loadFormData()
            }
        }
    }
}
</script>
